import React from "react";

export default (props: React.SVGAttributes<SVGElement>) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
<path d="M19.77 4.92998L21.17 6.32998L8.43 19.07L2.83 13.47L4.23 12.07L8.43 16.27L19.77 4.92998ZM19.77 2.09998L8.43 13.44L4.23 9.23998L0 13.47L8.43 21.9L24 6.32998L19.77 2.09998Z" fill="black"/>
</svg>
;
